/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { env, routes } from "../../app-constants";
import Footer from "../../components/Footer/Footer";
import OrderSummaryInfo from "../../components/Order/OrderSummaryInfo";
import OrderSummaryList from "../../components/Order/OrderSummaryList";
import RecommendedItems from "../../components/Order/RecommendedItems";
import { RootState } from "../../state/store/store";
import Nav from "../../components/Nav/Nav";
import withData from "../../highOrderComponents/withData";
import { useDispatch, useSelector } from "react-redux";
import {
  calculateOrderAmount,
  fetchRecommendations,
} from "../../state/actions/orderActions";
import { MenuItem } from "../../state/types/menuTypes";

const ConfirmOrder = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const order = useSelector((state: RootState) => state.order);

  const selectedVendor = useSelector(
    (state: RootState) => state.selectedVendor
  );

  const menu = useSelector(
    (state: RootState) => state.menu.menuByVendor[selectedVendor.data.id]
  );

  const recommendations = order.recommendations;

  // Initial load - fetch recommendations once
  useEffect(() => {
    dispatch(fetchRecommendations(selectedVendor.data.id, order));
  }, []);

  // Recalculate order amount whenever userOrder or coupon changes
  useEffect(() => {
    dispatch(calculateOrderAmount(selectedVendor.data.id, order));
  }, [order.userOrder, order.appliedCoupon]);

  const paymentSummary = order.orderAmount.paymentSummary;

  return (
    <div className="ConfirmOrder col-md-8 offset-md-2 d-flex flex-column">
      <Nav
        className="nav-header"
        goTo={routes.ORDER_FLOW.PLACE_ORDER.PATH}
        title={`Ordering from ${
          selectedVendor
            ? selectedVendor.data.storeName
            : env.REACT_APP_VENUE_NAME
        }`}
      />
      <div className="summary-container d-flex flex-column">
        {recommendations.fetchStatus === "success" &&
          recommendations.items.length > 0 &&
          menu && (
            <RecommendedItems
              items={recommendations.items as MenuItem[]}
              menu={menu}
              vendorId={selectedVendor.data.id}
            />
          )}
        <OrderSummaryList
          // @ts-ignore - Project Upgrade
          items={paymentSummary.items.filter(
            // @ts-ignore - Project Upgrade
            (item) =>
              item.itemType !== "ServiceCharge" && item.itemType !== "Discount"
          )}
          // @ts-ignore - Project Upgrade
          totalPayment={paymentSummary.total}
        />
        <OrderSummaryInfo
          // @ts-ignore - Project Upgrade
          chargeItems={paymentSummary.items.filter(
            // @ts-ignore - Project Upgrade
            (item) => item.itemType === "ServiceCharge"
          )}
          // @ts-ignore - Project Upgrade
          discountItems={paymentSummary.items.filter(
            // @ts-ignore - Project Upgrade
            (item) => item.itemType === "Discount"
          )}
          // @ts-ignore - Project Upgrade
          totalPayment={paymentSummary.total}
          // @ts-ignore - Project Upgrade
          subtotal={paymentSummary.subTotals}
          vendorId={selectedVendor.data.id}
        />
        {env.REACT_APP_DIETARY_NOTE && selectedVendor ? (
          <div className="special-order-note">
            For specific dietary requests including all allergies please contact
            the restaurant directly on&nbsp;
            <a href={`tel:${selectedVendor.data.phoneNumber}`}>
              {selectedVendor.data.phoneNumber}
            </a>
          </div>
        ) : (
          <></>
        )}
        {env.REACT_APP_SPECIAL_ORDER_NOTE ? (
          <div className="special-order-note">
            {env.REACT_APP_SPECIAL_ORDER_NOTE}
          </div>
        ) : (
          <></>
        )}
        <div className="fixed-btn-row">
          <div className="mt-auto">
            <Link
              className="btn btn-secondary btn-reverse-arrow"
              style={{ marginBottom: "10px" }}
              to={routes.ORDER_FLOW.PLACE_ORDER.PATH}
            >
              Add or remove items
            </Link>
          </div>
        </div>
        <div className="fixed-btn-row">
          <div className="mt-auto">
            {(order.warnings || []).length > 0 ? (
              <button
                className="btn btn-primary btn-arrow"
                onClick={() => {
                  dispatch({
                    type: "SET_ORDER_COUPON",
                    payload: { couponCode: "" },
                  });
                  history.push(routes.ORDER_FLOW.CONFIRM_CONTACT.PATH);
                }}
              >
                Proceed to Pay
              </button>
            ) : (
              <Link
                className="btn btn-primary btn-arrow"
                to={routes.ORDER_FLOW.CONFIRM_CONTACT.PATH}
              >
                Proceed to Pay
              </Link>
            )}
          </div>
          <Footer className="mt-auto" />
        </div>
      </div>
    </div>
  );
};

export default withData()(ConfirmOrder);
